import React from 'react'

import { StaticImage } from 'gatsby-plugin-image'

import Image from '@components/Content/Image/Image'
import Showcase from '@components/Content/Showcase/Showcase'
import HomepageSolutionsGrid from '@components/Pages/Homepage/HomepageSolutionsGrid'

import { ACFImageType } from '@contracts/Components/ACF'
import { SolutionsGridShowcaseType, SolutionsMainShowcaseType } from '@contracts/Homepage'

import * as styles from './HomepageSolutions.module.scss'

interface Props {
	mainShowcase: SolutionsMainShowcaseType
	gridShowcase: SolutionsGridShowcaseType
	image: ACFImageType
}

const HomepageSolutions = (props: Props) => {
	return (
		<section className={styles.solutions}>
			<div className={styles.content}>
				<Showcase data={props.mainShowcase} reverse contentStyle="full" className={styles.mainShowcase}>
					<Image image={props.mainShowcase.image} altText="" />
				</Showcase>

				<Showcase
					data={props.gridShowcase}
					className={styles.gridShowcase}
					reverseLaptop
					noTopPadding
					noBottomPadding
				>
					<HomepageSolutionsGrid cards={props.gridShowcase.cards} />
				</Showcase>
			</div>
			<div className={styles.backgroundImage}>
				<StaticImage
					src="../../../images/solutions-background.png"
					width={1920}
					className={styles.image}
					alt=""
				/>
			</div>
		</section>
	)
}

export default HomepageSolutions
